module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAAjElEQVRYhe3TQQqCUBSF4d94YNQOBKlltIbGuhXnbcBB26gVNHPWIkIq5a1ARUGwkU2aX4TOv4HzweWCUv9eAPB8VReYEuPp634Xpyvb0d8EEMABlO/WbzfubjncdqP/Ak75I4LgYAmAqYYFnEAAARxA1px9T2j6hmsGX8yAY3+LAOM3RG8owDIASqkP2vsdHU4as1QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/incab/common/LanguageSelector/icons/ru.png
// module id = ./src/incab/common/LanguageSelector/icons/ru.png
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons